import { render, staticRenderFns } from "./PersonElement.vue?vue&type=template&id=7151a31f&"
import script from "./PersonElement.vue?vue&type=script&lang=js&"
export * from "./PersonElement.vue?vue&type=script&lang=js&"
import style0 from "./PersonElement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports